import React, { useEffect, useState } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { useLanguage } from '../../hooks/useLanguage'

const ProTeam = () => {
  const { lang } = useLanguage()

  return (
    <section className=''>
      <div>
        <h2 className='text-4xl font-bold text-center text-[#333]'>
          <span className='bg-green-underline bg-no-repeat bg-[length:100%_55px] bg-[position:left_bottom_0px] inline-block'>
            1F8について
          </span>
        </h2>
      </div>
      <p className='text-xl text-center text-black py-8 md:py-16 leading-170'>
        弊社はホームページ制作から、ブランディング、管理・サポートまで行うウェブトータルサポート企業です。“日本の中小企業様を支え、日本経済を支える”それが弊社のミッションです。バイリンガルなチームメンバーが最新テクノロジー技術を駆使し、お客様の集客力を上げるお手伝いをします！
      </p>
      <div className='py-4 sm:py-6'>
        <StaticImage
          src='../../img/pro/map.webp'
          alt='1f8チームマップ'
          className='object-cover w-full'
          loading='lazy'
        />
      </div>
    </section>
  )
}

export default ProTeam
